'use strict';

document.addEventListener('DOMContentLoaded', () => {
    // Use event delegation for better performance
    document.body.addEventListener('click', (event) => {
        // Check if the clicked element matches the dropdown-link class
        if (event.target.matches('.dropdown-link')) {
            const parentMenu = event.target.closest('ul[aria-label]');
            if (parentMenu) {
                const categoryId = parentMenu.getAttribute('aria-label');
                const categoryURL = parentMenu.getAttribute('categoryURL');

                // Set the active nav link in sessionStorage
                console.log('function called', categoryURL);
                sessionStorage.setItem('activeNavLink', categoryURL);
            }
        }
    });

    //Rendering active nav-link
    const navLinks = document.querySelectorAll('.nav-link'); // Get all navigation links
    navLinks.forEach(link => {
        if (link.getAttribute('href') === window.location.pathname || link.getAttribute('href') === window.location.href) {
            link.classList.add('nav-link-active'); // Add the "active" class to the clicked link
            sessionStorage.setItem('activeNavLink', link.getAttribute('href')); // Store the ID of the clicked link in sessionStorage
        }
    });


    // Add click event listeners to each navigation link
    navLinks.forEach(link => {
        link.addEventListener('click', function () {
            navLinks.forEach(link => link.classList.remove('nav-link-active')); // Remove the "active" class from all nav links
            link.classList.add('nav-link-active'); // Add the "active" class to the clicked link
            sessionStorage.setItem('activeNavLink', this.getAttribute('href')); // Store the ID of the clicked link in sessionStorage
        });
    });

    const activeLinkHref = sessionStorage.getItem('activeNavLink'); // Check if there's an active link stored in sessionStorage

    // If an active link was stored, add the "active" class to it
    if (activeLinkHref) {
        const queryElement = `a[href="` + activeLinkHref + `"]`;
        const activeLink = document.querySelector(queryElement);
        if (activeLink) {
            activeLink.classList.add('nav-link-active');
        }
    }

    //setting active link ig SHOP NOW of catg is clicked
    const shopNowLinks = document.querySelectorAll('.shop-now-link');
    shopNowLinks.forEach(link => {
        link.addEventListener('click', () => {
            sessionStorage.setItem('activeNavLink', link.getAttribute('href')); // Store the ID of the clicked link in sessionStorage
        })
    });

    // code optimization on 23 Apr 2025
    const logoLinks = document.getElementById('header-nav').querySelectorAll('a');
    logoLinks.forEach(link => {
        if (!link.classList.contains('dropdown-link') && link.getAttribute('id') !== 'dropdownAccountSelector') {
            link.addEventListener('click', () => {
                sessionStorage.setItem('activeNavLink', '');
            });
        }
    })

    //script to render initial state of suggestion wrapper onClicking on search icon
    document.getElementById('search-icon-btn-mobile').addEventListener('click', () => {
        const q = '';
        const url = window.SearchSuggestionsURL + q;

        const xhr = new XMLHttpRequest(); // Create a new XMLHttpRequest object

        // Set up the `onreadystatechange` event handler
        xhr.onreadystatechange = () => {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    // Parse and log the response JSON
                    const response = xhr.responseText;
                    const suggestionsWrapper = document.querySelector('.suggestions-wrapper');
                    suggestionsWrapper.innerHTML = xhr.responseText;
                } else {
                    console.error('Error:', xhr.status, xhr.statusText);
                }
            }
        };

        try {
            xhr.open('GET', url, true); // Open the request
            xhr.setRequestHeader('Content-Type', 'application/json'); // Set headers if needed
            xhr.send(); // Send the request
        } catch (error) {
            console.log(error);
        }
    });

    const inputField = document.querySelector('.suggestions-search-input');
    const submitButton = document.querySelector('button[name="search-results"]');

    // Function to toggle the button visibility
    function toggleButtonVisibility() {
        if (inputField.value.trim() === '') {
            submitButton.style.display = 'none'; // Hide the button
        } else {
            submitButton.style.display = 'block'; // Show the button
        }
    }

    toggleButtonVisibility();   // Initially hide the button if the input is empty
    inputField.addEventListener('input', toggleButtonVisibility);   // Listen for input events on the text field
});